import gql from "graphql-tag";
import {client} from "./client";
import {CreateEntityContact} from "../../schema/CreateEntityContactLink";
import {FetchResult, Mutation} from "../../types";

const getMutation = (patchObject: {[key: string]: any}): any => ({
    variables: {input: {entitycontact: patchObject}},
    mutation: gql`${CreateEntityContact}`
});

export async function createEntitycontact (patchObject: {[key: string]: any}) {
    const result: FetchResult<Mutation> = await client.mutate(getMutation(patchObject));
    const entitycontact = result.data?.createEntitycontact?.entitycontact;
    if (!entitycontact) {
        throw new Error('failed to create entity contact link');
    } else {
        await client.cache.reset();
        return entitycontact;
    }
}
